import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import './App.css';
import Layout from "./Components/Layout/Layout";
import Home from "./Pages/Home";
import News from "./Pages/News";
import VideoPlayer from "./Pages/newsVideo";
import PartnerUpdateDetail from "./Pages/PartnerUpdateDetail";
import SaudiaMoments from "./Pages/SaudiaMoments";
import LayoutInnerPage from "./Components/Layout/LayoutInnerPage";
import EnterToWin from "./Pages/EnterToWin";
import EnterToWinSurvey from "./Pages/EnterToWinSurvey";
import Thanks from "./Pages/Thanks";
import TermsAndConditions from "./Pages/TermsAndConditions";
import LatestContent from "./Pages/LatestContent";
import { LanguageProvider } from "./context/LanguageContext";
import Index from "./Pages/Game/Index";

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Suspense fallback="Loading....">
          <Routes>
            <Route element={<Layout />} >
              <Route exact path="" element={<Home />} />
            </Route>
            <Route element={<LayoutInnerPage/>}>
              <Route exact path="/news/:id" element={<News />} />
              {/* <Route path="/video/:id" element={<VideoPlayer />} /> */}
              <Route path="/video/:id/:slug?" element={<VideoPlayer />} />
              {/* <Route exact path="/partner-update/:id" element={<PartnerUpdateDetail />} /> */}
              <Route exact path="/partner-update/:slug" element={<PartnerUpdateDetail />} />
              <Route exact path="/saudia-moments" element={<SaudiaMoments />} />
              <Route exact path="/enter-to-win/:competition_id" element={<EnterToWin />} />
              <Route exact path="/enter-to-win-survey" element={<EnterToWinSurvey />} />
              <Route exact path="/thanks" element={<Thanks />} />
              <Route exact path="/terms-and-conditions" element={<TermsAndConditions />} />
              {/* <Route exact path="/game-page" element={<Index />} /> */}
              <Route exact path="/games-predictor" element={<Index />} />
              <Route exact path="/games-predictor/prediction" element={<Index />} />
              <Route exact path="/games-predictor/entry" element={<Index />} />
              <Route exact path="/games-predictor/survey" element={<Index />} />
              <Route exact path="/games-predictor/confirmation" element={<Index />} />
              <Route exact path="/latest-content" element={<LatestContent />} />
            </Route>
          </Routes>
        </Suspense>
      </Router>
    </LanguageProvider>
  );
}

export default App;
